import { SharedModule } from './../../shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResetComponent } from './reset/reset.component';
import { ChangePassComponent } from './change-pass.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ChangePassService } from './change-pass.service';
import { SummaryComponent } from './summary/summary.component';
import { ResetWithStepsComponent } from './reset-with-steps/reset-with-steps.component';
import { MatCardModule } from '@angular/material';
import { ResetHomeComponent } from './reset/reset-home/reset-home.component';

@NgModule({
	imports: [
		CommonModule,
		SharedModule,
		FormsModule,
		ReactiveFormsModule,
		MatCardModule
	],
	declarations: [
		ChangePassComponent,
		ResetComponent,
		SummaryComponent,
		ResetWithStepsComponent,
		ResetHomeComponent
	],
	providers: [ChangePassService]
})
export class ChangePassModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/change-pass/change-pass.module.ts